/**
 * The viewer's locale preferences, most-preferred first, for formatting only.
 *
 * Returns `readonly string[]` rather than a union of supported languages on
 * purpose: it is deliberately incompatible with the console's `Languages` type
 * so it can never be substituted for `getPlatformRegion()`, which means
 * *deployment* region and drives `Accept-Language`, reCAPTCHA keys and Sentry.
 */
export const getLocale = (): readonly string[] => {
  const { languages, language } = window.navigator;

  return languages?.length ? languages : [language];
};
